import { IOrderFactory } from '../../entities/order/Order'
import { IProductResponse, transformProduct } from '../product/ProductTransformer'
import castListItems from '../castListItems'
import { parseIsoDateTime } from '../../utils/parse-date'
import { OrderProductStatus } from '../../entities/order-product/OrderProduct'

type OrderProductStatusType = typeof OrderProductStatus

export interface IOrderResponse {
  'order_id':                number
  'status':                  string
  'status_code':             OrderProductStatusType[keyof OrderProductStatusType]
  'create_date':             string // "2026-04-06T16:00:20+03:00"
  'total':                   number
  'store_id':                number
  'subtotal':                number
  'admin_note':              string
  'customer_note':           string
  'picking_hub_id':          number
  'moved_to_in_progress':    boolean
  'is_final_purchase_order': boolean
  'purchase_order_id':       string | null
  'products':                IProductResponse[]
}

const normalizePurchaseOrderId = (raw: unknown): string | null => {
  if (typeof raw !== 'string') return null
  const trimmed = raw.trim()
  return trimmed ? trimmed : null
}

export const transformOrder = (order: IOrderResponse): IOrderFactory => {
  return {
    orderId:              order.order_id,
    status:               order.status,
    statusCode:           order.status_code,
    adminNote:            order.admin_note,
    customerNote:         order.customer_note,
    createDate:           parseIsoDateTime(order.create_date),
    pickingHubId:         order.picking_hub_id,
    storeId:              order.store_id,
    subtotal:             order.subtotal,
    total:                order.total,
    wasMovedToInProgress: order.moved_to_in_progress || false,
    isFinalPurchaseOrder: order.is_final_purchase_order === true,
    purchaseOrderId:      normalizePurchaseOrderId(order.purchase_order_id),
    products:             castListItems(order.products, transformProduct),
  }
}
